import { Controller } from "@hotwired/stimulus"
import { marked } from "marked"

// Renders the text content of data-markdown-target="source" as HTML using marked.js (GFM).
// Usage:
//   <div data-controller="markdown">
//     <script type="text/template" data-markdown-target="source"><%= raw_text %></script>
//     <div data-markdown-target="output"></div>
//   </div>
//
// Or with a single element holding the raw text as data attribute:
//   <div data-controller="markdown" data-markdown-text-value="<%= escape_javascript(text) %>">
//     <div data-markdown-target="output"></div>
//   </div>
export default class extends Controller {
  static targets = ["source", "output"]
  static values  = { text: String }

  connect() {
    this._render()
  }

  textValueChanged() {
    this._render()
  }

  _render() {
    const raw = this.hasTextValue && this.textValue
      ? this.textValue
      : this.hasSourceTarget
        ? this.sourceTarget.textContent
        : null

    if (!raw || !this.hasOutputTarget) return

    this.outputTarget.classList.add("ai-answer")
    this.outputTarget.innerHTML = marked.parse(raw, { gfm: true, breaks: false })
  }
}
